import { tuple } from './tuple';

export const FIELD_DATE_FORMATS = tuple('yyyy-MM-dd', 'MM-dd-yy', 'MM-dd');
